'use client';
import { twMerge } from 'tailwind-merge';
import { Search } from 'lucide-react';

export interface ISearchInput {
  placeholder?: string;
  onSearchClick?: () => void;
  searchValue?: string;
  onSearchChange?: (value: string) => void;
  className?: string;
  showSearch?: boolean;
}

export function SearchInput({
  placeholder = 'Search...',
  onSearchClick,
  searchValue = '',
  onSearchChange,
  className = '',
  showSearch = true,
}: ISearchInput) {
  if (!showSearch) return null;

  const launcher = onSearchClick && !onSearchChange;
  const buttonClass =
    'flex min-h-11 min-w-11 items-center justify-center rounded-md border border-slate-200 bg-white text-gray-700 hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-orange-700';

  return (
    <div className={twMerge('w-full sm:w-auto', className)}>
      <div className="hidden w-full max-w-xs sm:block lg:max-w-sm">
        {launcher ? (
          <button
            type="button"
            aria-label="Search this Crew"
            onClick={onSearchClick}
            className={`${buttonClass} w-full justify-start gap-2 px-3`}>
            <Search aria-hidden="true" size={18} />
            <span>{placeholder}</span>
          </button>
        ) : (
          <div className="relative">
            {onSearchClick ? (
              <button
                type="button"
                aria-label="Search this Crew"
                onClick={onSearchClick}
                className={`${buttonClass} absolute left-0 top-0 border-0 bg-transparent`}>
                <Search aria-hidden="true" size={18} />
              </button>
            ) : (
              <Search
                aria-hidden="true"
                className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-gray-500"
                size={18}
              />
            )}
            <input
              type="text"
              value={searchValue}
              onChange={(event) => onSearchChange?.(event.target.value)}
              placeholder={placeholder}
              className="min-h-11 w-full rounded-md border border-slate-200 py-2 pl-11 pr-4 focus:border-gray-900 focus:outline-none"
            />
          </div>
        )}
      </div>

      <div className="sm:hidden">
        {onSearchClick && (
          <button
            type="button"
            aria-label="Search this Crew"
            onClick={onSearchClick}
            className={buttonClass}>
            <Search aria-hidden="true" className="h-4 w-4" />
          </button>
        )}
      </div>
    </div>
  );
}
